<template>
  <div class="container">
    <!-- Header -->
    <Header></Header>
    <!-- 主内容 -->
    <div class="container">
      <!-- 二级导航-->
      <div class="second-banner">
        <div v-for="(item,index) in secbanner" :key="index">
          {{item}}
        </div>
      </div>
    </div>
    <!-- Footer -->
    <Footer></Footer>
  </div>
</template>

<script>
  import axios from 'axios';
  var CONFIG = require('../../common/config.js');
  var base_url = CONFIG.API_URL.BASE_URL;

  export default {
    data () {
      return {
        id: 0,//解决方案idsolutionInfo:'',
        secbanner: [
          '产品简介',
          '核心优势',
          '应用场景',
          '客户案例',
          '联系我们'
        ],
      }
    },
    created: function (options) {
      var that = this;



      //获取案例
      that.getSolutionInfo();
    },
    watch:{
      $route:function () {
        var that = this;
        //获取案例
        that.getSolutionInfo();
      }
    },
    methods: {
      //获取案例
      getSolutionInfo:function(){
        var that = this;

        //页面携带参数
        var id = that.$route.query.id;
        that.id = id;

        axios.post(base_url+'front/getInfoDetail', {id:id}).then(function (res) {
          //console.log(res);
          var data = res.data;
          if(data.code == 0){
            var data = data.result;
            that.solutionInfo = data;
          }
        });
      },

      /**
       * 解决方案详情
       */
      solutionDetail:function(e){
        var id = e.currentTarget.dataset.id;
        this.$router.push({ path: '/solutionDetail?id='+id })
      },



    }
  }

</script>

<style>
  @import url("./solutionDetail.css");
</style>



// WEBPACK FOOTER //
// src/views/solutionDetail/solutionDetail.vue